/**
 * Spinner Button Component
 */
import { CircularProgress, makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import React from 'react';
const useStyles = makeStyles((theme) => ({
    spinner: {
        margin: theme.spacing(-6, 1, -6, 0),
        color: theme.palette.secondary.main,
    },
    disabledPrimary: {
        backgroundColor: `${theme.palette.primary.light} !important`,
        opacity: 0.3,
    },
    disabledSecondary: {
        backgroundColor: `${theme.palette.secondary.main} !important`,
        opacity: 0.3,
    },
    disabledInherit: {
        backgroundColor: 'inherit',
        opacity: 0.3,
    },
}));
const SpinnerButton = props => {
    const styles = useStyles();
    const { loading, caption, ...rest } = props;
    const colorProp = props.color;
    let disabledColorClass = '';
    switch (colorProp) {
        case 'primary':
            disabledColorClass = styles.disabledPrimary;
            break;
        case 'secondary':
            disabledColorClass = styles.disabledSecondary;
            break;
        default:
            disabledColorClass = styles.disabledInherit;
            break;
    }
    if (!props.disabled) {
        disabledColorClass = '';
    }
    return (React.createElement(Button, Object.assign({}, rest, { disabled: rest.disabled || loading, className: disabledColorClass }),
        loading && React.createElement(CircularProgress, { size: 24, thickness: 5, className: styles.spinner }),
        props.caption));
};
export default SpinnerButton;
//# sourceMappingURL=SpinnerButton.js.map